import Style from 'ol/style/Style';
import Stroke from 'ol/style/Stroke';
import Fill from 'ol/style/Fill';

export class LineStyle {

  public getLineStyle(color: string, strokeWidth: number): Style {
    return new Style({
      stroke: new Stroke({
        color,
        width: strokeWidth
      }),
      fill: new Fill({
        color: 'rgba(255,255,0,0.5)'
      })
    });
  }

}
